import {
  APOLLO_STATE_PROP_NAME,
  initializeApollo
} from "./chunk-4QHS7QVS.mjs";
import {
  useAuthToken
} from "./chunk-VNJKQT4X.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-KEBUAQNP.mjs";

// src/hooks/use-apollo/use-apollo.ts
import { useMemo } from "react";
var useApollo = (pageProps, props) => {
  const token = useAuthToken((s) => s.token);
  const state = pageProps[APOLLO_STATE_PROP_NAME];
  const store = useMemo(
    () => {
      var _a;
      return initializeApollo(state, __spreadProps(__spreadValues({}, props), {
        headers: __spreadProps(__spreadValues({}, props == null ? void 0 : props.headers), {
          authorization: !token ? (_a = props == null ? void 0 : props.headers) == null ? void 0 : _a.authorization : token
        })
      }));
    },
    [state, props, token]
  );
  return store;
};

export {
  useApollo
};
//# sourceMappingURL=chunk-DMQN7QHN.mjs.map